require("../alk-authentication/module");

(function (angular) {

  angular.module("tm.supportChat", ["alk.authentication"]);
  
})(window.angular);

require("./tmSupportChatSmall.directive");


// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/tm-support-chat/module.js